import React, { useEffect, useState } from 'react'

import { qs } from '@brands/ui/utils'
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { logService } from '@/services/log-service'
import { localStorageService, sessionStorageService } from '@/services/storage-service'
import { useAppState } from '@/states/app-state'

import { authService, urlHelpers } from './core'
import { selectCpaClient } from './redux/ducks/appDuck'
import { signalRAutoStartAndCleanUp, SignalRContext } from './utils/signalR'

export default function SignalRProvider(props) {
  const profile = useAppState((state) => state.profile)
  const selectedCpaClientId = useSelector(selectCpaClient)
  const [signalRConnection, setSignalRConnection] = useState()
  const location = useLocation()

  const companyId = profile && profile.conum
  const employeeCompanyNumber =
    profile && profile.employee && profile.employee.empConum && parseInt(profile.employee.empConum, 10)
  const employeeNumber = profile && profile.employee && profile.employee.empnum && parseInt(profile.employee.empnum, 10)
  const version = profile && profile.version

  // SignalR
  useEffect(() => {
    try {
      const conumOrCpa = authService.isCpaUser() ? selectedCpaClientId : companyId
      const qsData = {
        conum: conumOrCpa,
        empConum: employeeCompanyNumber,
        empnum: employeeNumber,
        version,
        reactAppVersion: process.env.REACT_APP_VERSION,
        jwtGuid: authService.getJwtGuid(),
        currentUrl: location.pathname,
        bfp: localStorageService.getBfp(),
        sfp: sessionStorageService.getSfp(),
      }
      const search = qs.stringify(qsData)
      const connection = new HubConnectionBuilder()
        .withUrl(urlHelpers.getAbsoluteURL(`/hub/Main?${search}`), {
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
          accessTokenFactory: () => authService.getToken(),
        })
        .configureLogging('warn')
        .build()

      const userId = authService.isUserAuthenticated()
      if (conumOrCpa && userId) {
        setSignalRConnection(connection)
        return signalRAutoStartAndCleanUp(connection)
      }
    } catch (error) {
      logService.error('Error connecting signalR', { error })
    }
  }, [companyId, selectedCpaClientId])

  return <SignalRContext.Provider value={signalRConnection}>{props.children}</SignalRContext.Provider>
}
